'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('clinic.timeslots', {
    url: 'timeslots/?provider&date&showOcsCompatibilityModal',
    templateUrl: '/views/partials/clinic/timeslots.html',
    controller: 'ClinicTimeslotsCtrl',
    data: {
      noScrollOnSearch: true,
    },
    resolve: {
      ocsData: function(ClinicService, clinic) {
        return ClinicService.getOCSData(clinic.id);
      },
      pageTitle: function($pageTitle, clinic) {
        $pageTitle.set('Calendar - ' + clinic.name + ' - Opencare');
      },
      filters: function(clinic, $stateParams, OpencareConstants) {
        let date = $stateParams.date;
        if (!date || moment(date).isBefore(moment(), 'day')) {
          date = moment().format(OpencareConstants.apiDateFormat);
        }
        var filters = {
          provider: _.find(clinic.providers, function(provider) {
            return provider.id == $stateParams.provider;
          }) || OpencareConstants.allProviders,
        };
        if (date && moment.utc(date, OpencareConstants.apiDateFormat, true).isValid()) {
          filters.dateGte = moment(date).startOf('week')
            .format(OpencareConstants.apiDateFormat);
          filters.dateLt = moment(date).startOf('week')
            .add(7, 'days')
            .format(OpencareConstants.apiDateFormat);
        }
        return filters;
      },
      reservedAppointmentSlotsData: function(filters, ReservedAppointmentSlotService, clinic, OpencareConstants) {
        if (filters.provider === OpencareConstants.allProviders) {
          return ReservedAppointmentSlotService.listForClinic(clinic.id, filters);
        }
        return ReservedAppointmentSlotService.listForProvider(filters.provider.id, filters);
      },
      appointmentTimeSlotsData: function(filters, AppointmentService, clinic, OpencareConstants) {
        if (filters.provider == OpencareConstants.allProviders) {
          return AppointmentService.listAppointmentsForTimeSlot('clinic', clinic.id, filters);
        }
        return AppointmentService.listAppointmentsForTimeSlot('doctor', filters.provider.doctor.id, filters, clinic.id);
      },
      providerAvailabilityBlocks: function(filters, ProviderAvailabilityBlockService, clinic, OpencareConstants) {
        if (filters.provider === OpencareConstants.allProviders) {
          return ProviderAvailabilityBlockService.listForClinic(clinic.id);
        }
        return ProviderAvailabilityBlockService.find(filters.provider.id);
      },
    },
  });
});

angular.module('ClinicApp').controller('ClinicTimeslotsCtrl', function(filters, reservedAppointmentSlotsData, appointmentTimeSlotsData, providerAvailabilityBlocks, $stateParams, $scope, ocsData, $location, clinic, numOpenIbSlots, ProviderService, ClinicService, OpencareConstants, OCModalUtil, CurrentUser, GrowlService) {

  OpencareAnalytics.trackPageView({
    pageType: OpencareAnalytics.pageTypes.INSTANT_BOOK_MANAGER,
    pageName: clinic.name,
    content: {
      view: 'practice',
      is_real_practice: String(!CurrentUser.isImpersonated()),
    },
    practiceId: clinic.id,
    userId: CurrentUser.getUser().id,
  });

  $scope.filters = filters;
  $scope.reservedAppointmentSlotsData = reservedAppointmentSlotsData;
  $scope.appointmentTimeSlotsData = appointmentTimeSlotsData;
  $scope.providerAvailabilityBlocks = providerAvailabilityBlocks;

  $scope.clinic = clinic;

  $scope.pms = clinic?.ocsMetadata?.pmsName || clinic?.metadata?.practiceManagementSoftware?.name;

  $scope.ocsSyncStatus = _.get(ocsData, 'clinic.opencareSyncStatus');
  $scope.showLinkBlock = $scope.ocsSyncStatus !== 'LIVE' && $scope.ocsSyncStatus !== 'NEVER_LAUNCHED';

  switch ($scope.ocsSyncStatus) {
    case 'LIVE':
      $scope.syncStatusToCss = 'online only-ocs-btn';
      $scope.syncStatusToText = 'Syncing';
      break;
    case 'LIVE_WITH_WARNING':
      $scope.syncStatusToCss = 'warning only-ocs-btn';
      $scope.syncStatusToText = 'Warning';
      break;
    case 'DISABLED':
    case 'PAUSED':
      $scope.syncStatusToCss = 'offline only-ocs-btn';
      $scope.syncStatusToText = 'Offline';
      break;
    default:
      $scope.syncStatusToCss = 'inactive';
      $scope.syncStatusToText = 'Inactive';
  }

  if ($scope.pms) {
    $scope.ocsEligibilityText = 'Practice PMS: ' + $scope.pms;
    $scope.ocsEligibilityIcon = 'fa-cog';
  } else {
    $scope.ocsEligibilityText = 'Connect my PMS';
    $scope.ocsEligibilityIcon = 'fa-refresh';
  }

  $scope.instantBookMappingsControl = {
    isEnabled: Boolean(clinic?.instantBookConfiguration?.autoGenerationSettings?.isEnabled),
    isRegenerating: false,

    regenerate: function() {
      if ($scope.instantBookMappingsControl.isRegenerating) {
        return;
      }
      $scope.instantBookMappingsControl.isRegenerating = true;
      ClinicService.generateInstantBookMappings($scope.clinic.id)
        .then(function() {
          GrowlService.success(`${$scope.pms} sync configuration refreshed.`);
        })
        .finally(function() {
          $scope.instantBookMappingsControl.isRegenerating = false;
        });
    },
  };

  $scope.reservedSlotProviders = $scope.clinic.providers
    .filter((provider) => provider.onlineBooking)
    .sort((a, b) => a.doctor.name > b.doctor.name ? 1 : -1);

  $scope.showLessThan10SlotsBanner = shouldShowLessThan10SlotsBanner();
  $scope.fullyBookedResponse = false;
  $scope.numOpenIbSlots = numOpenIbSlots;

  $scope.open = $stateParams.showOcsCompatibilityModal;
  if ($scope.open) {
    $location.search('showOcsCompatibilityModal', null);
  }

  $scope.ibWarningInaccurateResponse = function() {
    updateIbSlotsWarningTracking(OpencareConstants.lessThan10IbSlotsWarning.LAST_SLOTS_INACCURATE_RESPONSE);
    $scope.showLessThan10SlotsBanner = false;
    $scope.$parent.showLessThan10SlotsWarning.value = false;

    var hasLocalMed = _.some($scope.clinic.providers, function(provider) {
      return _.get(provider, 'metadata.localMedSettings.isEnabled', false) === true;
    });
    var practiceManagementSoftware = _.get($scope.clinic, 'metadata.practiceManagementSoftware.name', '').toLowerCase();
    var eligibleForOpencareSync = _.includes(['dentrix', 'eaglesoft', 'opendental', 'abeldent'], practiceManagementSoftware);
    if (hasLocalMed && !eligibleForOpencareSync) {
      window.open(OpencareConstants.calendly.calendarSupport, '_blank');
    } else {
      window.open(OpencareConstants.calendly.calendarResync, '_blank');
    }
  };

  $scope.ibWarningAccurateResponse = function() {
    updateIbSlotsWarningTracking(OpencareConstants.lessThan10IbSlotsWarning.LAST_SLOTS_ACCURATE_RESPONSE);
    $scope.showLessThan10SlotsBanner = false;
    $scope.$parent.showLessThan10SlotsWarning.value = false;
  };

  $scope.providerNoticeOptions = new Array(5);
  $scope.currentSelectedNoticeProvider = $scope.reservedSlotProviders[0] ?? null;
  $scope.lastSelectedNoticeProvider = $scope.currentSelectedNoticeProvider;
  $scope.showDoctorDropdownInProviderNotice = () =>
    $scope.filters.provider === OpencareConstants.allProviders;
  $scope.selectNoticeProvider = (provider) => {
    $scope.currentSelectedNoticeProvider = provider;
    $scope.lastSelectedNoticeProvider = provider;
  };
  $scope.updateProviderDaysNoticeForAppointment = (days) => {
    $scope.currentSelectedNoticeProvider.daysNoticeForAppointment = days;
    ProviderService.updateProvider(
      $scope.currentSelectedNoticeProvider.id,
      {
        daysNoticeForAppointment: days,
      },
    );
  };
  $scope.getProviderNoticeSummary = () => {
    if ($scope.currentSelectedNoticeProvider.daysNoticeForAppointment === 0) {
      return '(Patients can book same-day appointments)';
    }

    const numDays = $scope.currentSelectedNoticeProvider.daysNoticeForAppointment;
    const unitText = numDays === 1 ? 'day' : 'days';
    return `(Patients must book a minumum of ${numDays} ${unitText} in advance)`;
  };

  $scope.updateSearchParams = function(filters) {
    $scope.currentSelectedNoticeProvider = filters.provider === OpencareConstants.allProviders
      ? $scope.lastSelectedNoticeProvider
      : filters.provider;
    $location
      .search('provider', filters.provider?.id ?? null)
      .search('date', filters.dateGte || null)
      .replace();
  };

  $scope.updateSearchParams($scope.filters);

  $scope.openOCSEligibilityModal = function(showBackButton) {
    OCModalUtil.showCustomModal({
      windowClass: 'modal-oc-hours js-modal-scroll-region',
      templateUrl: '/views/modals/_ocs-eligibility.html',
      controller: 'ModalOCSEligibilityCtrl',
      resolve: OCModalUtil.createResolve({
        clinic: $scope.clinic,
        showBackButton,
      }),
    });
  };

  if ($scope.open) {
    $scope.openOCSEligibilityModal();
  }

  function shouldShowLessThan10SlotsBanner() {
    if ($scope.$parent.showLessThan10SlotsWarning.value) {
      updateIbSlotsWarningTracking(OpencareConstants.lessThan10IbSlotsWarning.BANNER_DISPLAYED_AT);
      return true;
    }
    return false;
  }

  function updateIbSlotsWarningTracking(lessThan10IbSlotsWarningObjKey) {
    ClinicService.updateClinic(clinic, {
      metadata: {
        lessThan10IbSlotsWarning: {
          ...$scope.clinic.metadata?.lessThan10IbSlotsWarning,
          [lessThan10IbSlotsWarningObjKey]: moment().format(),
        },
      },
    });
  }
});
